import * as React from 'react';
import { Props, ReactElement, StatelessComponent } from 'react';

export const Splash: StatelessComponent = (props: Props<HTMLDivElement>): ReactElement<Props<HTMLDivElement>> => (
    <div className="chat-message-room-splash">{props.children}</div>
);
